/**
 * @module Root
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/* tslint:disable:no-any */
/* tslint:disable:no-angle-bracket-type-assertion */

import { enableDebugTools, disableDebugTools } from '@angular/platform-browser';
import { ApplicationRef, enableProdMode } from '@angular/core';
import { SETTINGS } from './settings';

// Environment Providers
const PROVIDERS: any[] = [
  // common env directives
];

// Angular debug tools in the dev console
// https://github.com/angular/angular/blob/86405345b781a9dc2438c0fbe3e9409245647019/TOOLS_JS.md
let decModuleRef = <T>(value: T): T => {
  return value;
};

if ('production' === SETTINGS.ENV) {
  enableProdMode();

  // Production
  decModuleRef = (modRef: any) => {
    disableDebugTools();

    return modRef;
  };

  // PROVIDERS = [
  //   // ...PROVIDERS,
  //   // custom providers in production
  // ];
} else {
  decModuleRef = (modRef: any) => {
    const appRef = modRef.injector.get(ApplicationRef);
    const cmpRef = appRef.components[0];

    const ng = (<any>window).ng;
    enableDebugTools(cmpRef);
    (<any>window).ng.probe = ng.probe;
    (<any>window).ng.coreTokens = ng.coreTokens;
    return modRef;
  };

  // Development
  // PROVIDERS = [
  //   // ...PROVIDERS,
  //   // custom providers in development
  // ];
}

export const decorateModuleRef = decModuleRef;

export const ENV_PROVIDERS = [...PROVIDERS];
